'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { EntityTypes } from 'AdsUI/lib/Constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { deleteEntity } from 'AdsUI/actions/EntityManagementActions';
import { usageTracker } from 'AdsUI/lib/usageTracker';

const DeleteEntityButtonContainer = ({
  entityType,
  adAccount,
  parent,
  campaignEntity,
  entity,
  dispatch
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const onReject = useCallback(() => {
    setModalOpen(false);
  }, []);
  const onConfirm = useCallback(() => {
    dispatch(deleteEntity({
      network: adAccount.network,
      entityType,
      adAccountId: adAccount.accountId,
      campaignId: campaignEntity.id,
      adGroupId: entityType === EntityTypes.ADGROUP ? entity.id : parent.id,
      adId: entity.id,
      keywordId: entity.id
    }));
    usageTracker.track('modifyCampaign', {
      action: 'Deleted entity',
      entityType,
      network: adAccount.network
    });
    setModalOpen(false);
  }, [dispatch, entityType, adAccount, campaignEntity, parent, entity]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ScopeWrapper, {
      tooltipKey: "deleteAds",
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: () => setModalOpen(true),
        use: "tertiary-light",
        size: "extra-small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteButton"
        })
      })
    }), modalOpen && /*#__PURE__*/_jsx(UIConfirmModal, {
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaigns.management.deleteEntity.button.${adAccount.network}.${entityType}`
      }),
      confirmUse: "danger",
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.management.deleteEntity.header"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaigns.management.deleteEntity.message.${adAccount.network}.${entityType}`
      }),
      size: "auto",
      use: "danger",
      onReject: onReject,
      onConfirm: onConfirm
    })]
  });
};

export default connect()(DeleteEntityButtonContainer);